import React from "react";
import { Link, withRouter } from "react-router-dom";
import { composeArrayForRatings } from "../../CommonMethods";
import RatingStar from "../../RatingStar";

import ImageLoader from "../../ImageLoader";
import RatingStart from "../../RatingStar";

const ReactDOMServer = require("react-dom/server");
const HtmlToReactParser = require("html-to-react").Parser;

class SponsoredPopup extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      showPopUp: false,
      focusTestimonial: false,
      focusCaseStudy: false,
      focusVideo: false,
    };
    this.escFunction = this.escFunction.bind(this);
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({ showPopUp: true });
      }
    }, 20000);
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.props.setShowPopUp(false);
    }
  };

  getBadgeSVG = (award, uid) => {
    const badgeHTML = !!award.svg_badge_with_category
      ? award.svg_badge_with_category
      : award.svg_badge;
    const htmlToReactParser = new HtmlToReactParser();
    const reactElement = htmlToReactParser.parse(badgeHTML);
    const reactHtml = ReactDOMServer.renderToStaticMarkup(reactElement);
    return (
      <div className="clsSVG" id={uid}>
        {reactHtml ? reactElement : null}
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.state.showPopUp ? (
          <section
            class="overlay_popup overlay_grey singleCompetitorPopup"
            aria-hidden="false"
          >
            <div class="popBox">
              <a
                href="#"
                class="close-overlay"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.setShowPopUp(false);
                }}
              ></a>
              <div class="popup_overlay_screen">
                <div class="modal-content">
                  <div class="modal-body">
                    <div class="singleCompetitorPopup_content_box">
                      <div class="left_section">
                        <div class="topContentBox">
                          <span class="badge-content sponsored-badge-content">
                            Sponsored Content
                          </span>
                          <h1>
                            Can't see enough references? Checkout this{" "}
                            {this.props.vendor} alternative.
                          </h1>
                          <div class="content_box">
                            <div class="category">
                              <div class="category_txt">Category:</div>
                              <ul class="list_category">
                                {!!this.props.category ? (
                                  Array.isArray(this.props.category) ? (
                                    this.props?.category?.map((obj, index) => (
                                      <li key={`Spn_Cat_${index}`}>
                                        <Link to={obj.link}>{obj.name}</Link>
                                      </li>
                                    ))
                                  ) : (
                                    <li>
                                      <Link to={this.props?.category?.link}>
                                        {this.props?.category?.name}
                                      </Link>
                                    </li>
                                  )
                                ) : (
                                  ""
                                )}
                              </ul>
                            </div>
                            <p>{this.props.description}</p>
                          </div>
                        </div>

                        <div class="btn_visit_profile">
                          <Link to={this.props.profile_url}>Visit profile</Link>
                        </div>
                      </div>
                      <div class="right_section">
                        <div class="rightSectionContentBlock">
                          <div class="top_header">
                            <div class="logo">
                              <img src={this.props.logo} alt="" />
                            </div>

                            {this.props.rating?.aggregate_score ? (
                              <div class="starRating">
                                <div class="starIcon">
                                  <RatingStart
                                    starCount={composeArrayForRatings(
                                      this.props?.rating?.aggregate_score
                                    )}
                                    inline={true}
                                    withoutO
                                  />
                                </div>
                                <div class="ratingTxt">
                                  {this.props.rating.aggregate_score} / 5.0
                                </div>
                              </div>
                            ) : null}
                            <div class="svgLogo">
                              <ul>
                                {[
                                  ...this.props?.awards,
                                  ...this.props?.reports,
                                ].map((obj, index) => (
                                  <li key={`sis_${index}`}>
                                    {this.getBadgeSVG(obj, `inndiv_${index}`)}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                          <div class="footer_content_box">
                            <div class="txt_block">
                              <span class="count">
                                {this.props.reviews_count}
                              </span>
                              <span class="txt">{` customer references`}</span>
                            </div>
                            <div class="customerReferenceList">
                              <ul>
                                <li>
                                  <span class="count">
                                    {this.props.testimonial_count}
                                  </span>
                                  <span class="txt">Testimonials</span>
                                </li>
                                <li>
                                  <span class="count">
                                    {this.props.casestudy_count}
                                  </span>
                                  <span class="txt">Case Studies</span>
                                </li>
                                <li>
                                  <span class="count">
                                    {this.props.video_count}
                                  </span>
                                  <span class="txt">Customer Videos</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : null}
      </React.Fragment>
    );
  }
}

export default withRouter(SponsoredPopup);
